<template>
	<div class="card shadow-sm">
		<div class="card-header bd-b-0 d-flex justify-content-between">
            <h5 class="lh-5 mg-b-0">Please confirm your order details below</h5>
        </div>
        <div v-if="trade.type === 'fixed-income'" class="table-responsive">
            <table class="table table-dashboard mg-b-0" aria-describedby="fixed-income-request-table">
                <thead>
                    <tr>
                        <th scope="col" class="tx-medium text-center">Type</th>
                        <th scope="col" class="tx-medium text-center">ISIN</th>
                        <th scope="col">Description</th>
                        <th scope="col" class="tx-medium text-right">Volume</th>
                        <th scope="col" class="tx-medium text-center">ReInvestment</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(request, index) in trade.trade_data" :key="index">
                        <td class="tx-color-03 tx-medium text-center" :class="request.type">{{ request.type|toStartCase }}</td>
                        <td class="tx-color-03 tx-medium text-center">{{ request.fixed_income.security_isin }}</td>
                        <td class="tx-color-03 tx-medium">{{ request.fixed_income.security_details.description }}</td>
                        <td class="tx-medium text-right">{{ request.volume|toNumber }}</td>
                        <td class="tx-color-03 tx-medium text-center">{{ request.maturity|toStartCase|placeholder }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="trade.type === 'equity'" class="table-responsive">
            <table class="table table-dashboard mg-b-0" aria-describedby="equity-request-table">
                <thead>
                    <tr>
                        <th scope="col" class="tx-medium text-center">Type</th>
                        <th scope="col" class="tx-medium text-center">Ticker</th>
                        <th scope="col" class="tx-medium text-center">Volume</th>
                        <th scope="col" class="tx-medium text-center">Price</th>
                        <th scope="col" class="tx-medium text-center">Charges</th>
                        <th scope="col" class="tx-medium text-center">Est Consideration</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(request, index) in trade.trade_data" :key="index">
                        <td class="tx-medium text-center" :class="request.type">{{ request.type|toStartCase }}</td>
                        <td class="tx-medium text-center">
                            <a href="#view-equity" class="tx-color-03" data-toggle="modal" :data-request="index">{{ request.equity.symbol }}</a>
                        </td>
                        <td class="tx-medium text-center">{{ request.volume|toNumber }}</td>
                        <td class="tx-medium text-center">{{ request.price|toNumber }}</td>
                        <td class="tx-medium text-center">{{ request.charges|toCurrency(request.currency) }}</td>
                        <td class="tx-medium text-center">{{ request.net_consideration|toCurrency(request.currency) }}</td>
                    </tr>
                    <tr>
                        <td class="tx-medium Total" colspan="4">Total</td>
                        <td class="tx-medium text-center Total">{{ trade.trade_cost.charges|toCurrency(trade.currency) }}</td>
                        <td class="tx-medium text-center Total">{{ trade.trade_cost.net_consideration|toCurrency(trade.currency) }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="modal fade" id="view-equity" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                    <div class="modal-content">
                        <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <a href="" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </a>
                            <div class="media align-items-center">
                                <span class="d-none d-sm-block">
                                    <img src="#" alt="" class="mw-100" height="50" width="50">
                                </span>
                                <div class="media-body mg-sm-l-20">
                                    <h4 class="tx-18 tx-sm-20 mg-b-2"></h4>
                                    <p class="tx-13 tx-color-03 mg-b-0"></p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <ul class="list-group list-group-flush mg-b-0 tx-13">
                                <li class="list-group-item pd-x-0 d-flex justify-content-between">
                                    <span class="tx-medium">Price</span>
                                    <span class="tx-medium price"></span>
                                </li>
                                <li class="list-group-item pd-x-0 d-flex justify-content-between">
                                    <span class="tx-medium">1 Day Change</span>
                                    <span class="tx-medium day-change"></span>
                                </li>
                                <li class="list-group-item pd-x-0 d-flex justify-content-between">
                                    <span class="tx-medium">1 Yr Performance</span>
                                    <span class="tx-medium year-performance"></span>
                                </li>
                                <li class="list-group-item pd-x-0 d-flex justify-content-between">
                                    <span class="tx-medium">1 Yr High</span>
                                    <span class="tx-medium year-high"></span>
                                </li>
                                <li class="list-group-item pd-x-0 d-flex justify-content-between">
                                    <span class="tx-medium">1 Yr Low</span>
                                    <span class="tx-medium year-low"></span>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer pd-x-20 pd-y-15">
                            <button type="button" class="btn btn-white shadow-sm" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body pd-x-20 pd-b-10">
            <div class="float-right mg-b-15">
                <button type="button" class="btn btn-default flex-fill shadow-sm" @click="submit">Submit</button>
                <button type="button" class="btn btn-primary flex-fill mg-l-5 shadow-sm" @click="cancel">Cancel</button>
            </div>
        </div>
	</div>
</template>

<style lang="scss" scoped>
.media {
	img {
		object-fit: contain;
	}
}
</style>

<script>
import { trade } from '../../../../../mixins';

export default {
	mixins: [trade.equities],
	mounted() {
		// 	$('#view-equity').on('show.bs.modal', (e) => {
		// 		const { toNumber, placeholder } = this.$options.filters
		// 		const button = $(e.relatedTarget)
		// 		const request = this.trade.trade_data[button.data('request')]
		// 		const modal = $('#view-equity')

		// 		const { equity } = request

		// 		modal.find('.modal-header img').attr('src', equity.image_url).attr('alt', equity.stock_code)
		// 		modal.find('.modal-header h4').html(equity.symbol_name)
		// 		modal.find('.modal-header p').html(equity.symbol)

		// 		modal.find('.modal-body .price').html(toNumber(this.calculatePrice(equity)))
		// 		modal.find('.modal-body .day-change').html(toNumber(this.calculateDayChange(equity)))
		// 		modal.find('.modal-body .year-performance').html(placeholder())
		// 		modal.find('.modal-body .year-high').html(toNumber(equity.high_price))
		// 		modal.find('.modal-body .year-low').html(toNumber(equity.low_price))
		// 	})
	},
	methods: {
		submit() {
			this.$emit('submit-request');
		},
		cancel() {
			this.$emit('cancel-request');
		},
	},
	props: ['trade'],
};
</script>
